// extracted by mini-css-extract-plugin
export default {"history-of-transactions":"HistoryOfTransactions_history-of-transactions__UMuKR","history_list":"HistoryOfTransactions_history_list__MDci1"};